function getSupplierInfo () {
  let customer_id = $('#collection-supplier-wrapper').attr('data-customer-id');
  const collectionId = $('#collection-supplier-wrapper').attr('data-collection-id')

  Shopify.getCustomerToken(customer_id).then((token) => {
    $.ajax({
      type: "GET",
      url: `https://api.marcothepolo.com/api/v1/sp-supplier/search-info?collection_id=${collectionId}`,
      dataType: 'json',
      headers:{"MTP-CUSTOMER-TOKEN":token},
      contentType: 'application/json; charset=utf-8',
      success: function(data) {
        if(data.code === 10000 && data.data && data.data.data) {
          const { id,avatar_img, store_name_en, supplier_name_en, supplier_type, establish_time, staff_num, office_area, annual_sales, recommend_en,is_followed } = data.data.data
          const storeName = store_name_en || supplier_name_en
  
          // show supplier product list
          const supplierInfoHtml = '<div class="d-flex align-items-center">'
            + (avatar_img ? `<img class="avatar-img" src=${avatar_img} />` : '<div class="avatar-img"></div>')
            + '<div class="text ml-1">'
            + '<h3><span class="storeName">' + storeName + '</span><button class="followbutton'+(is_followed==1? ' followbuttoning':'')+'"><span class="followicon"><i class="fkt-heart-o"></i></span><span class="followtext">'+(is_followed==1?'Following':'Follow')+'<span></button></h3>'
            + '<div class="info">'
            + (supplier_type === 'Featured' ? '<span class="tag mr-1">' + supplier_type + '</span>' : '')
            + '<span>' + (establish_time && !isNaN(establish_time.slice(0, 4)) ? `${new Date().getFullYear() - Number(establish_time.slice(0, 4))} yrs` : '') + (staff_num ? ` &middot; ${staff_num} staff` : '' ) + (office_area ? `<span> &middot; ${office_area} ㎡</span>` : '') + (annual_sales&&annual_sales!='Undisclosed' ? `<span class="d-none d-md-inline-block"> &middot; ${annual_sales}<span>` : '') + (supplier_type === 'Featured' ? '<span class="view-more ml-1">View More&gt;</span>' : '')+'</span>'
            + '</div></div></div>'
          $('#collection-supplier-wrapper .supplier-info').html(supplierInfoHtml)
          if(supplier_type!='Featured'){
            $('.collection-supplier-tab').hide();
          }
          // set profile
          const { main_category_en, crowd_en, style_en, feature_en, upper_new_rate_en, custom_capability_en, area_en, product_line_num, device_num, worker_num, qc_capability_en, factory_imgs, cert_imgs } = data.data.data
          let tagHtml = ''
          const arr = [main_category_en, crowd_en, style_en, feature_en, upper_new_rate_en, custom_capability_en]
          arr.forEach(item => {
            if(item) {
              item.replace(/，/g, ',').split(',').forEach(tag => {
                tagHtml += '<span class="tag">' + tag + '</span>'
              })
            }
          })
  
          const profileInfoHtml = "<h1>Editor's Highlight</h1>"
            + (recommend_en ? '<p>" ' + recommend_en + ' "</p>' : '')
            + '<div>' + tagHtml + '</div>'
          $('.supplier-profile .info').html(profileInfoHtml)
  
          if((factory_imgs && factory_imgs.length > 0) || (cert_imgs && cert_imgs.length > 0)) {
            let hasFactoryImage = false
            if(factory_imgs && factory_imgs.length > 0) {
              let imgsHtml = ''
              factory_imgs.forEach(item => {
                imgsHtml += '<div class="image-wrapper landscape-image"><img src="' + item + '" /></div>' 
              })
              $('.supplier-profile #factory').html('<div class="image-list ' + (factory_imgs.length === 1 ? 'justify-content-center' : '') + '">' + imgsHtml + '</div>')
              if(factory_imgs.length > 1) {
                $('.supplier-profile #factory-tab').text(`Factory Pictures (${factory_imgs.length})`)
              }
              $('.supplier-profile #factory-tab').show()
              $('.supplier-profile #factory-tab').tab('show')
              hasFactoryImage = true
            }
            if(cert_imgs && cert_imgs.length > 0) {
              let imgsHtml = ''
              cert_imgs.forEach(item => {
                imgsHtml += '<div class="image-wrapper"><img src="' + item + '" /></div>' 
              })
              $('.supplier-profile #certification').html('<div class="image-list ' + (cert_imgs.length === 1 ? 'justify-content-center' : '') + '">' + imgsHtml + '</div>')
              if(hasFactoryImage) {
                $('.supplier-profile .nav').addClass('has-certication')
              } else {
                $('.supplier-profile #certification-tab').tab('show')
              }
              if(cert_imgs.length > 1) {
                $('.supplier-profile #certification-tab').text(`Certification (${cert_imgs.length})`)
              }
              $('.supplier-profile #certification-tab').show()
            }
            $('.supplier-profile .image-list-wrapper').show()
          } else {
            $('.supplier-profile .supplier-item').addClass('justify-content-center')
          }
          $(".followbutton").off("click").on("click",function(){
            if (!Shopify.customer) {
              if($('#accountModal').length > 0) {
                $('#accountModal').modal();
              } else {
                window.location.href = theme.wishlist.login;
              }
              return false;
            }
            let customer_id = $('#collection-supplier-wrapper').attr('data-customer-id');
            
            Shopify.getCustomerToken(customer_id).then((data) => {
              let params = {
                target:'supplier',
                target_id:id
              }
              if(is_followed==0){
                $.ajax({
                  type: "POST",
                  url: 'https://api.marcothepolo.com/api/v1/sp-wishlist/add',
                  headers:{"MTP-CUSTOMER-TOKEN":data},
                  data: JSON.stringify(params),
                  dataType: 'json',
                  contentType: 'application/json; charset=utf-8',
                  success: function(data) {
                  if(data.code === 10000) {
                    $(".followbutton").addClass('followbuttoning')
                    $(".followtext").text('Following')
                    getSupplierInfo();
                    theme.toast({
                      message: "Follow successfully",
                      type: "success",
                      duration: 3000
                    })
                  }
                  }
                });
              }
              if(is_followed==1){
                $.ajax({
                  type: "POST",
                  url: 'https://api.marcothepolo.com/api/v1/sp-wishlist/cancel',
                  headers:{"MTP-CUSTOMER-TOKEN":data},
                  data: JSON.stringify(params),
                  dataType: 'json',
                  contentType: 'application/json; charset=utf-8',
                  success: function(data) {
                  if(data.code === 10000) {
                    $(".followbutton").removeClass('followbuttoning')
                    $(".followtext").text('Follow')
                    getSupplierInfo();
                  }
                  }
                });
              }
  
            })
        })
          $('#establish_time').text(establish_time || '-')
          $('#annual_sales').text(annual_sales || '-')
          $('#office_area').text(office_area || '-')
          $('#staff_num').text(staff_num || '-')
          $('#area').text(area_en)
          $('#product_line_num').text(product_line_num || '-')
          $('#device_num').text(device_num || '-')
          $('#worker_num').text(worker_num || '-')
          $('#qc_capability').text(qc_capability_en || '-')
          $('#upper_new_rate').text(upper_new_rate_en || '-')
          $('#custom_capability').text(custom_capability_en || '-')
        }
      }
    });
  })
}
$(document).ready(function(){
  const templateSuffix = $('#collection-supplier-wrapper').attr('data-template-suffix')
  if(templateSuffix === 'supplier-collection') {
    getSupplierInfo()
    const pageType = $('#collection-supplier-wrapper').attr('data-tab-type')
    if (pageType === 'hot') {
      $('#collection-supplier-wrapper #best-seller').tab('show')
    } else if (pageType === 'new') {
      $('#collection-supplier-wrapper #new-arrival').tab('show')
    } else {
      $('#collection-supplier-wrapper #all-products-tab').tab('show')
    }
    $('#collection-supplier-wrapper .supplier-info').on('click', '.view-more', function() {
      $('#collection-supplier-wrapper #profile-tab').tab('show')
    })
  }
})